import { Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import React, { useCallback } from "react";
import "./index.scss";

/**
 * 声明 CheckBox
 */
export const YituDeclareCheckBox: React.SFC<{
  value?: boolean;
  onChange?: (value: boolean) => void;
}> = props => {
  const { onChange } = props;

  const handleChange = useCallback(
    (evt: CheckboxChangeEvent) => {
      const { checked } = evt.target;
      onChange && onChange(checked);
    },
    [onChange]
  );

  return (
    <Checkbox className={"YituDeclareCheckBox"} onChange={handleChange}>
      我已经阅读并同意依图公司
      <a
        href="https://www.yitutech.com/cn/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        《隐私政策》
      </a>
      及
      <a
        href="https://www.yitutech.com/cn/legal"
        target="_blank"
        rel="noopener noreferrer"
      >
        《法律声明》
      </a>
    </Checkbox>
  );
};
